import { useState } from 'react';
import type { ChoiceView } from '../model/choices';

/** Persisted server selections, separate from the command's editable answers. */
export function SelectionReview({ rows }: { rows: ChoiceView['review'] }) {
  const [page, setPage] = useState(0);
  if (!rows?.length) return null;
  const pages = Math.ceil(rows.length / 40), current = Math.min(page, pages - 1);
  return <details className="selection-review" open>
    <summary>Saved selection · {rows.length} entries</summary>
    <div className="selection-review-body">
      <dl>{rows.slice(current * 40, (current + 1) * 40).map((row, i) => <div key={i}><dt>{row.label}</dt><dd>{row.value}</dd></div>)}</dl>
      {pages > 1 && <div className="record-actions"><button type="button" className="button" disabled={!current} onClick={() => setPage(current - 1)}>Previous entries</button><span>Page {current + 1} of {pages}</span><button type="button" className="button" disabled={current + 1 === pages} onClick={() => setPage(current + 1)}>Next entries</button></div>}
    </div>
  </details>;
}
